module.exports = __webpack_public_path__ + "img/rogue.c1c29ec5.jpg";